const middleware = {}

middleware['site_state'] = require('../middleware/site_state.js');
middleware['site_state'] = middleware['site_state'].default || middleware['site_state']

export default middleware
